import React, { useState, useEffect } from "react";
import Table2 from "../Table2/Table2";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ReactLoading from 'react-loading';
import Switch from "react-switch";
import { deletePackage, editStatusPackagee, loadPackages } from "../../Redux/Actions/ActionPackages";
import AddPackage from "./AddPackages";
import EditPackages from "./EditPackages";
import AddFeatures from "./AddFeatures";
import { useNavigate } from "react-router-dom";
import './Packages.css'
import AddPackageToVendor from "./AddPackageToVendor";

function Packages() {
    let role = localStorage.getItem('roleA');
    let dispatch = useDispatch();
    let navigate = useNavigate()
    const AllPackages = useSelector(state => state.packagee.AllPackages)
    const loadingAllPackages = useSelector(state => state.packagee.loadingAllPackages)
    let langLocal = localStorage.getItem('absherLang');
    const [arr, setArr] = useState([]);
    const [open, setOpen] = useState(false)
    const [openEdit, setopenEdit] = useState(false)
    const [openFea, setopenFea] = useState(false)
    const [openAddVen, setopenAddVen] = useState(false)
    const [arrAddVan, setarrAddVan] = useState([]);
    const [arrFea, setArrFea] = useState([]);
    const [t, i18n] = useTranslation();
    const [statusID, setstatusID] = useState(null);
    const [loadStatusID, setloadStatusID] = useState(false);
    useEffect(() => {
        i18n.changeLanguage(localStorage.getItem('absherLang'));
        dispatch(loadPackages())
    }, []);
    const handleDelete1 = (id) => {
        dispatch(deletePackage(id));
    }
    const editStatus = (id, is_active) => {
        setstatusID(id)
        let active;
        if (is_active === 0) {
            active = 1
        } else {
            active = 0
        }
        dispatch(editStatusPackagee(id, active, setloadStatusID))
    }
    const handleFeatures = (arr1) => {
        const formValues = {
            id: arr1.id,
        };
        setArrFea(formValues);
        setopenFea(true);
    }
    const handleAddVen = (arr1) => {
        const formValues = {
            id: arr1.id,
        };
        setarrAddVan(formValues);
        setopenAddVen(true);
    }
    const toFeatures = (id, name) => {
        navigate(`/features/${id}/${name}`)
    }
    const columns1 = [
        {
            name: <span className="color_spann">{t('name_en')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['name']}</span>
            )
        },
        {
            name: <span className="color_spann">{t('name_ar')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['name_ar']}</span>
            )
        },
        {
            name: <span className="color_spann">{t('desc_en')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['description']}</span>
            )
        },
        {
            name: <span className="color_spann">{t('desc_ar')}</span>,
            cell: (row) => (
                <span>{row['description_ar']}</span>
            )
        },
        {
            name: <span className="color_spann">{t('price')}</span>,
            cell: (row) => (
                <span>{row['price']}</span>
            )
        },
        {
            name: <span className="color_spann">{t('start_date')}</span>,
            cell: (row) => (
                <span>{row['start_date']}</span>
            )
        },
        {
            name: <span className="color_spann">{t('end_date')}</span>,
            cell: (row) => (
                <span>{row['end_date']}</span>
            )
        },
        {
            name: <span className="color_spann">{t('features')}</span>,
            cell: (row) => (
                <>
                    <i className="fa fa-eye icon_features features_plus" onClick={() => toFeatures(row.id, row.name)} ></i>
                    {
                        role === 2 ? (
                            <i className="fa fa-plus icon_features features_eye" onClick={() => handleFeatures(row)} ></i>
                        ) : ''
                    }
                </>
            )
        },
        {
            name: <span className="color_spann">Add to vendor</span>,
            cell: (row) => (
                <>
                    {
                        role !== '2' ? (
                            <>
                                <i className="fa fa-plus icon_features features_eye" onClick={() => handleAddVen(row)} ></i>
                            </>

                        ) : <span>-</span>
                    }
                </>
            )
        },
        {
            name: <span className="color_spann">{t('status')}</span>,
            cell: (row) => (
                <>
                    {
                        (row.id === statusID && loadStatusID === true) ? (
                            <ReactLoading type="cylon" color="#36ADB0" height={'35%'} width={'35%'} />
                        ) : (
                            <>
                                {
                                    row.is_active === 0 ? (
                                        <Switch onColor='#36ADB0' checkedIcon={false} uncheckedIcon={false} height={20} width={40} handleDiameter={15} checked={false} onChange={() => { editStatus(row.id, row.is_active) }} />
                                    ) : <Switch onColor='#36ADB0' checkedIcon={false} uncheckedIcon={false} height={20} width={40} handleDiameter={15} checked={true} onChange={() => { editStatus(row.id, row.is_active) }} />
                                }
                            </>
                        )

                    }
                </>
            )
        },
        {
            name: <span className="color_spann">actions</span>,
            cell: (row) => (
                <>
                    {
                        role !== '2' ? (
                            <>
                                <i className="fa fa-edit  icon_edit " onClick={() => handleEdit(row)}  ></i>
                                <i className="fa fa-trash icon_delete " onClick={() => handleDelete1(row.id)} ></i>
                            </>
                        ) : <span>No actions</span>
                    }
                </>
            )
        }
    ]
    const handleEdit = (arr1) => {
        const formValues = {
            id: arr1.id,
            name: arr1.name,
            name_ar: arr1.name_ar,
            description: arr1.description,
            description_ar: arr1.description_ar,
            price: arr1.price,
            start_date: arr1.start_date,
            end_date: arr1.end_date,
            is_active: arr1.is_active
        };
        setArr(formValues);
        setopenEdit(true);
    }
    return (
        <>
            <main>
                <div className="page_header" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    <h2>{t('packages')}</h2>
                    {
                        role !== '2' && (
                            <button onClick={() => setOpen(true)} >
                                <i className="fa fa-plus" ></i>
                                <span>{t('addPackage')}</span>
                            </button>
                        )
                    }
                </div>
                <div className="div_table" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    {
                        loadingAllPackages == false ? (
                            <Table2 showCheckbox={true} col={columns1} roo={AllPackages} />
                        ) : <div className="div_loading" ><ReactLoading type="spinningBubbles" color="#36ADB0" height={'7%'} width={'7%'} /></div>
                    }
                </div>
            </main>
            {
                open == true ? (
                    <AddPackage open={open} setOpen={setOpen} />
                ) : <></>
            }
            {
                openEdit == true ? (
                    <EditPackages arr={arr} open={openEdit} setOpen={setopenEdit} />
                ) : <></>
            }
            {
                openFea == true ? (
                    <AddFeatures arr={arrFea} open={openFea} setOpen={setopenFea} />
                ) : <></>
            }
            {
                openAddVen == true ? (
                    <AddPackageToVendor arr={arrAddVan} open={openAddVen} setOpen={setopenAddVen} />
                ) : <></>
            }
        </>
    );
}

export default Packages;